import { lazyInitializeOwaAccountsStore } from 'owa-account-store-init';
import {
    lazyInitializeTrueTimeStore,
    lazyGetStoreIsSettled,
    lazyGetStoreState,
    lazyGetMergeViewEnabledAccount,
    lazyAddMergedViewAvailabilityAccount,
    lazyRemoveMergedViewAvailabilityAccount,
} from 'owa-truetime';

export default async function initOWAAccount() {
    lazyInitializeOwaAccountsStore.importAndExecute();
    lazyInitializeTrueTimeStore.importAndExecute();
    lazyGetStoreIsSettled.import();
    lazyGetMergeViewEnabledAccount.import();
    lazyAddMergedViewAvailabilityAccount.import();
    lazyRemoveMergedViewAvailabilityAccount.import();
    lazyGetStoreState.import();

    return true;
}
